import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { ShieldOff } from "lucide-react";

const ROWS = [
  ["mortgage", "Mortgage (MLO) accounts", "Lead runs, data refresh, AI calls and texts"],
  ["surety", "Surety bond accounts", "Surety Autopilot calls and texts"],
];

export const DncBypassCard = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/dnc-bypass").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;

  const flip = async (k, v) => {
    try {
      const { data } = await api.put("/admin/dnc-bypass", { [k]: v });
      setS(data);
      window.dispatchEvent(new Event("dnc-bypass-changed"));
      toast.success(v ? "DNC scrubbing bypassed" : "DNC scrubbing back on");
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <Card className="mb-5 p-6" data-testid="dnc-bypass-card">
      <h3 className="mb-1 flex items-center gap-2 font-display font-bold text-slate-900"><ShieldOff className="h-4 w-4 text-red-600" /> Bypass DNC Scrubbing</h3>
      <p className="mb-3 text-xs text-slate-500">When a switch is on, new numbers for that side are not checked against the National/State DNC and litigator lists with RealValidation. Numbers already found on a list and leads who asked not to be contacted stay blocked. Saves instantly.</p>
      {ROWS.map(([k, label, desc]) => (
        <div key={k} className="flex items-center justify-between gap-4 border-b border-slate-100 py-3">
          <div>
            <div className="text-sm font-semibold text-slate-800">{label}</div>
            <div className="text-xs text-slate-500">{desc} - {s[k] ? <span className="font-semibold text-red-600" data-testid={`dnc-bypass-${k}-status`}>BYPASSED: not scrubbed</span> : <span data-testid={`dnc-bypass-${k}-status`}>scrubbed with RealValidation</span>}</div>
          </div>
          <Switch checked={!!s[k]} onCheckedChange={(v) => flip(k, v)} data-testid={`dnc-bypass-${k}-toggle`} />
        </div>
      ))}
    </Card>
  );
};
